import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  moderatorsWrapper: {
    paddingRight: 80,
    paddingLeft: 53,
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  moderatorItemWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
  },
  moderatorImagesWrapper: {
    width: 100,
    height: 48,
    objectFit: 'cover',
  },
  moderatorDetailsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  companyLogo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',

    border: '2px solid #EEEEEE',
    borderRadius: '8px',
    padding: 10,
  },
  speakerCompanyName: {
    fontFamily: 'Lato',
    fontSize: 11,
    fontWeight: 700,
  },
  speakerName: {
    fontSize: 12,
    fontFamily: 'Lato',
    fontWeight: 300,
  },
  websiteURLText: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 700,
  },
});
